import React from 'react'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types';

class MenuItem extends React.Component {
  render() {
    var isActive = this.context.router.route.location.pathname === this.props.to;
    return (
      <li onClick={this.props.onClick} className={`wizard-steps-navigation-list-item ${this.props.wrapperClassName} ${isActive ? 'active' : ''}` }>
          <Link to={this.props.to}>
            {this.props.children}
          </Link>
      </li>
    )
  }
}

MenuItem.contextTypes = {
  router: PropTypes.object
};

export default MenuItem;


// WEBPACK FOOTER //
// ./app/javascript/app/components/wizard_nav/menu_item.jsx